<div class="flex flex-col mainView my-2">
  <div class="lmo-frac-summary-stages">
    <sa-lmo-frac-home-card class="summary-frac-stages">
      <header class="my-1 py-2">
        <img src="/assets/icons/summary.svg" alt="Summary" />
        <span class="text-xl font-medium">Summary</span>
      </header>
      <main class="p-2">
        <div [ngClass]="'gridRows grid py-2 border-b-2 border-gray-400 grid-cols-' + summaryColumns">
          <div class="px-2 text-gray-700 font-bold"></div>
          <div *ngFor="let mesh of totals$ | async; trackBy: trackById">
            <div class="px-2 text-gray-700 font-bold">{{ mesh.type }} Mesh</div>
          </div>
        </div>
        <div [ngClass]="'gridRows grid py-2 border-b-2 border-gray-400 grid-cols-' + summaryColumns">
          <div class="px-2 text-gray-700">
            Total Pumped
          </div>
          <div *ngFor="let mesh of totals$ | async; trackBy: trackById">
            <div class="px-2 text-gray-700 font-bold">
              {{ mesh.actualVolume | approxBigNumber }}
            </div>
          </div>
        </div>
        <div [ngClass]="'gridRows grid py-2 border-b-2 border-gray-400 grid-cols-' + summaryColumns">
          <div class="px-2 text-gray-700">
            Total Planned
          </div>
          <div *ngFor="let mesh of totals$ | async; trackBy: trackById">
            <div class="px-2 text-gray-700 font-bold">
              {{ mesh.volume | approxBigNumber }}
            </div>
          </div>
        </div>
      </main>
    </sa-lmo-frac-home-card>
  </div>
  <div class="lmo-frac-detail-stages">
    <sa-lmo-frac-home-card class="detail-frac-stages">
      <header class="my-1 py-2">
        <img src="/assets/icons/sandi-wave.svg" alt="SANDi" />
        <span class="text-xl font-medium">Detail</span>
      </header>
      <main class="p-2">
        <div [ngClass]="'gridRows grid py-2 border-b-2 border-gray-400 grid-cols-' + detailColumns">
          <div class="px-2 text-gray-700 font-bold">
            Stage #
          </div>
          <div class="px-2 text-gray-700 font-bold">
            Completion Time
          </div>
          <div *ngFor="let mesh of totals$ | async; trackBy: trackById">
            <div class="px-2 text-gray-700 font-bold">{{ mesh.type }} Mesh</div>
          </div>
        </div>
        <div
          *ngFor="let stage of completedFracStagesMeshRecord$ | async; trackBy: trackById"
          [saAllowedAccountRolesEnabledFor]="['admin', 'dispatcher']"
          [ngClass]="'gridRows grid py-2 border-b-2 border-gray-400 grid-cols-' + detailColumns"
          [routerLink]="['./', 'lmo_frac_stages_modal', 'stage', asFracStageMeshRecord(stage).stageNumber]"
        >
          <div class="px-2 text-gray-700">
            {{ stage.stageNumber }}
          </div>
          <div class="px-2 text-gray-700">
            {{ stage.completedTimestamp | date: 'H:mma MM/dd/yy' }}
          </div>
          <div *ngFor="let mesh of totals$ | async; trackBy: trackById">
            <div class="px-2 text-gray-700 font-bold">
              {{ getMeshPumpedVolume(stage, mesh.id) | number: '1.0-0' }}
            </div>
          </div>
        </div>
      </main>
    </sa-lmo-frac-home-card>
  </div>
</div>
<router-outlet></router-outlet>
